import { createFileRoute, Link } from '@tanstack/react-router';
import { Trans, useTranslation } from 'react-i18next';

import { useAuthEmail } from '@/components/auth/shared/auth-email';
import { ResetPasswordForm } from '@/components/auth/reset-password/reset-password-form';
import { AuthCard } from '@/components/auth/shell/auth-card';
import { AuthSplitShell } from '@/components/auth/shell/auth-split-shell';
import { AuthTopLink } from '@/components/auth/shell/auth-top-link';
import { AUTH_HEADLINE } from '@/components/ui/typography';
import { ROUTES } from '@/constants/routes';
import { loadNamespaces } from '@/lib/i18n/i18n';

export const Route = createFileRoute('/_public/reset-password')({
  loader: () => loadNamespaces('auth'),
  staticData: { title: 'route.reset_password.title' },
  component: ResetPasswordPage,
});

const TopBar = () => {
  const { t } = useTranslation('auth');

  return (
    <AuthTopLink to={ROUTES.FORGOT_PASSWORD}>
      {t('reset_password.top_back')}
    </AuthTopLink>
  );
};

function ResetPasswordPage() {
  const { t } = useTranslation('auth');
  const email = useAuthEmail();

  return (
    <AuthSplitShell topBar={<TopBar />}>
      <h1 className={AUTH_HEADLINE}>{t('reset_password.heading')}</h1>

      <AuthCard>
        {email ? (
          <div className="flex flex-col gap-5">
            <p className="text-fg-3 text-fs-13 leading-relaxed">
              <Trans
                i18nKey="reset_password.code_sent_to"
                ns="auth"
                values={{ email }}
                components={{ b: <b className="text-fg-1" /> }}
              />
            </p>
            <ResetPasswordForm email={email} />
          </div>
        ) : (
          <p className="text-fg-3 text-fs-13 text-center">
            <Trans
              i18nKey="reset_password.missing_email"
              ns="auth"
              components={{
                a: (
                  <Link
                    to={ROUTES.FORGOT_PASSWORD}
                    className="text-fg-1 font-semibold underline-offset-4 hover:underline"
                  />
                ),
              }}
            />
          </p>
        )}
      </AuthCard>
    </AuthSplitShell>
  );
}
